import React, {Component} from 'react';

import portraitIcon from '../img/ic_perm_device_information_white_48px.svg';

import '../css/MobileLandscapeMessage.css';

class MobileLandscapeMessage extends Component {
    render() {
        return (
            <div className="mobile-landscape-message-container">
                <div>
                    <img src={portraitIcon} alt="portrait icon"/>
                </div>
                <div className="mobile-landscape-message-title">
                    For the best experience, please view in Portrait mode
                </div>
                <div className="mobile-landscape-message-subtitle">
                    Thanks for understanding!
                </div>
            </div>
        )
    }
}

export default MobileLandscapeMessage;



// WEBPACK FOOTER //
// ./src/components/MobileLandscapeMessage.js